(function () {
  var io;
  function observe(root) {
    var els = (root || document).querySelectorAll('.mcc-reveal:not(.is-in), .mcc-zoom:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }
  function start() {
    if (document.documentElement.classList.contains('mcc-intro-lock')) {
      document.addEventListener('mcc:entered', function () { observe(); }, { once: true });
    } else {
      observe();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();